// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.Coc_outerContainer__8agfj {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* Full height for centering */
  background-color: #edf6f778; /* Light background for contrast */
  overflow: hidden; /* Prevent overflow if needed */
}

  
.Coc_chatContainer__tkcrq {
  width: 100%;
  height: 100%;
  max-width: 1300px;
  max-height: 1200px;
  overflow: hidden !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
  display: flex;
  flex-direction: column !important;
  position: relative; /* Ensure it's fixed to the screen */
}

  .Coc_header__NMYv8 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    background-color: #ffffff; /* White background for the header */
    border-bottom: 1px solid #e0e0e0; /* Separator line */
  }
  
  .Coc_botInfo__EU6fE {
    display: flex;
    align-items: center;
  }
  
  .Coc_botIcon__6vATY {
    width: 50px; /* Fixed size for consistency */
    height: 50px;
    border-radius: 50%; /* Circular icon */
    margin-right: 5px; /* Space between icon and text */
  }
  
  .Coc_botDetails__JYn28 {
    display: flex;
    flex-direction: column; /* Stack name and status */
  }
  
  .Coc_botName__YYZqs {
    font-size: 17px;
    font-weight: bold; /* Bold font for bot name */
  }
  
  .Coc_onlineStatus__wgmzs {
    font-size: 0.775rem; /* Smaller font for online status */
    color: #6c757d; /* Gray color for status */
    display: flex; /* Use flexbox to align dot and text */
    align-items: center; /* Center vertically */
  }
  
  .Coc_statusDot__V\\+wN4 {
    margin-left: 5px;
    width: 8px; /* Size of the dot */
    height: 8px; /* Size of the dot */
    background-color: #4caf50; /* Green color */
    border-radius: 50%; /* Make it circular */
    margin-right: 5px; /* Space between dot and text */
  }
  
  .Coc_chatWindow__Rp0IJ {
    flex-grow: 1; /* Let it take up remaining space */
    padding: 1rem; /* Space for chat messages */
    overflow-y: auto; /* Enable vertical scroll */
    overflow-x: hidden;
    background-color: #ffffff; /* White background for chat */
  }
  
  .Coc_messageContainer__ZB65G {
    display: flex;
    margin: 5px 0; /* Adjusted margin for closer spacing */
  }
  
  .Coc_leftMessage__Rm4vy {
    justify-content: flex-start; /* Align left for bot messages */
    text-align: start;
  }
  
  .Coc_rightMessage__R67Jq {
    justify-content: flex-end; /* Align right for user messages */
    text-align: start;
  }
  
  .Coc_message__znKSt {
    padding: 15px 15px; /* Padding for message bubbles */
    border-radius: 10px; /* Rounded corners for messages */
    align-items: center; 
    display: flex;
    max-width: 50%; /* Limit width of messages */
    color: #333; /* Text color */
    position: relative; 
    word-wrap: break-word; /* Ensure long text wraps properly */
  }
  
  .Coc_soundButton__1HKsw {
    margin-left: 10px; /* Add space between the text and the sound icon */
    cursor: pointer;
    transition: color 0.3s;
    align-self: flex-end;
  }
  
  .Coc_soundButton__1HKsw:hover {
    color: #333;
  }
  
  .Coc_botMessage__dZ63w {
    background-color: #ebeaea; 
  }
  
  .Coc_userMessage__MKIVA {
    background-color: #c8e6c9; 
  }
  
  .Coc_avatar__HtfhF {
    width: 50px; /* Avatar size */
    height: 50px;
    border-radius: 50%; /* Circular avatar */
    margin: 0 10px; /* Space around avatar */
  }
  
  /* Input Section */
  .Coc_inputSection__RDnsb {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background-color: #ffffff;
    border-radius: 0 0 20px 20px;
    position: sticky;
    bottom: 0; 
    width: 100%;
  }
  
  
  /* Wrapper for the custom input */
  .Coc_inputWrapper__P3Y34 {
    display: flex;
    align-items: flex-end;
    padding: 4px 8px;
    /* border: 1px solid #e0e0e0; */
    border-radius: 20px;
    background-color: #ebeaea;
    margin-right: 16px; 
    position: relative;
    width: 100%;
    /* min-width: 300px; */
    max-width: 1000px; 
    margin: 0 auto;
  }
  
  /* Custom input styling */
  .Coc_customInput__xXONf {
    flex-grow: 1;
    border: transparent;
    outline: none;
    background-color: transparent;
    padding: 8px;
    font-size: 1rem;
    line-height: 24px;
    resize: none; /* Disable manual resizing */
    overflow-y: auto; /* Add scrollbar if content overflows */
    color: inherit;
  }
  
  /* Attachment button styling */
  .Coc_attachButton__WCfK1 {
    color: inherit;
    margin-right: 8px;
  }
  
  
  /* Mic button positioning */
  .Coc_micButton__M4lN7 {
    color: inherit;
    margin-right: 8px;
    transition: all 0.3s ease;
  }
  
  /* Send Button styling */
  .Coc_sendButton__S9Wp7 {
    background-color: #c9d1d8;
    color: #000;
    border: none;
    border-radius: 50%;
    padding: 10px;
    width: 40px;
    height: 40px;
    transition: background-color 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .Coc_disabledButton__nJXbJ {
    opacity: 0.5;
    cursor: not-allowed; 
  }
  
  
  /* Dark mode styling for input wrapper */
  .Coc_darkInputWrapper__NEiC7 {
    background-color: #333;
    border: 1px solid #555;
  }
  
  
  /* Pulse effect when listening */
  .Coc_micButton__M4lN7.Coc_listening__7E9ls {
    color: #ff4081; /* Color to indicate active listening */
    animation: Coc_pulse__4J0kM 1s infinite;
  }
  
  /* Add pulse effect around the mic icon when listening */
  .Coc_listeningPulse__CNdAH {
    border: 3px solid rgba(0, 150, 255, 0.5);
    border-radius: 50%;
    padding: 8px;
    animation: Coc_pulse__4J0kM 1.5s infinite;
  }
  
  /* Pulsing animation for listening mode */
  @keyframes Coc_pulse__4J0kM {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      transform: scale(1.2);
      opacity: 0.8;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  /* Listening waveform animation */
  @keyframes Coc_wave__8t0r5 {
    0%,
    100% {
      transform: scaleY(1);
    }
    50% {
      transform: scaleY(1.5);
    }
  }
  
  .Coc_listeningWave__jRHu4 {
    display: flex;
    gap: 2px;
  }
  
  .Coc_waveBar__FOV-z {
    width: 5px;
    height: 16px;
    background: #2196f3;
    animation: Coc_wave__8t0r5 1s infinite ease-in-out;
    animation-delay: calc(0.2s * var(--i));
  }
  
  .Coc_inputWrapper__P3Y34:focus-within {
    border-color: #000000;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  }
  
  .Coc_spinner__TEeDt {
    width: 20px;
    height: 20px;
    border: 3px solid #ddd;
    border-top: 3px solid #3f51b5; /* or any color matching your theme */
    border-radius: 50%;
    animation: Coc_spin__sV3o1 1s linear infinite;
  }
  
  @keyframes Coc_spin__sV3o1 {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  
  /* Hover effect for send button */
  .Coc_sendButton__S9Wp7:hover {
    background-color: #0056b3;
  }
  
  /* Custom scrollbar for WebKit browsers (Chrome, Safari) */
  .Coc_chatWindow__Rp0IJ::-webkit-scrollbar {
    width: 10px; /* Width of the scrollbar */
    border-radius: 10px; /* Rounded corners */
  }
  
  .Coc_chatWindow__Rp0IJ::-webkit-scrollbar-thumb {
    background-color: #007bff; /* Color of the scrollbar thumb */
    border-radius: 10px; /* Rounded corners for the thumb */
  }
  
  .Coc_chatWindow__Rp0IJ::-webkit-scrollbar-thumb:hover {
    background-color: #0056b3; /* Darker color on hover */
  }
  
  /* Custom scrollbar for Firefox */
  .Coc_chatWindow__Rp0IJ {
    scrollbar-width: thin; /* Make the scrollbar thinner */
    scrollbar-color: #007bff #f0f4f8; /* Thumb color and track color */
  }
  
  .Coc_chatWindow__Rp0IJ::-moz-scrollbar {
    border-radius: 10px; /* Rounded corners for Firefox */
  }
  
  /* Optional: Adjust the appearance of the scrollbar track in Firefox */
  .Coc_chatWindow__Rp0IJ::-moz-scrollbar-track {
    background: #f0f4f8; /* Track color */
  }
  
  .Coc_chatWindow__Rp0IJ::-moz-scrollbar-thumb {
    background-color: #007bff; /* Color of the scrollbar thumb */
    border-radius: 10px; /* Rounded corners for the thumb */
  }
  
  .Coc_chatWindow__Rp0IJ::-moz-scrollbar-thumb:hover {
    background-color: #0056b3; /* Darker color on hover */
  }
  
  /* Add style for the delete icon */
  .Coc_deleteIcon__W893G {
    cursor: pointer;
  }
  
  .Coc_backButtonContainer__9zZLV {
    display: flex;
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
    padding: 1rem;
    background-color: #f9f9f9; /* Light background for the button section */
    width: 100%; /* Ensure the button container takes up full width */
  }
  
  .Coc_backButton__9qk2X {
    background-color: #c9d1d8 !important; /* Color of the Back to Home button */
    color: #000 !important;
    border-radius: 20px !important;
    padding: 10px 20px !important;
    text-transform: none; /* Disable uppercase */
  }
  
  /* .typingIndicator {
    display: flex;
    gap: 5px;
    margin: 0.5rem 1rem;
  }
  
  .typingDot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #888;
    animation: typing 0.8s infinite;
  }
  
  .typingDot:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .typingDot:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes typing {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  } */
  
  .Coc_typingDots__BtzfO {
    display: flex;
    gap: 4px;
  }
  
  .Coc_dot__4V2-P {
    width: 8px;
    height: 8px;
    background-color: #aaa;
    border-radius: 50%;
    animation: Coc_blink__OaKTI 1s infinite;
  }
  
  .Coc_dot__4V2-P:nth-child(2) {
    animation-delay: 0.2s;
  }
  
  .Coc_dot__4V2-P:nth-child(3) {
    animation-delay: 0.4s;
  }
  
  @keyframes Coc_blink__OaKTI {
    0%,
    20%,
    100% {
      opacity: 0.2;
    }
    50% {
      opacity: 1;
    }
  }
  
  /* Responsive positioning if needed */
  @media (max-width: 600px) {
    .Coc_backButtonContainer__9zZLV {
      padding: 0.5rem;
    }
  
    .Coc_backButton__9qk2X {
      font-size: 0.875rem;
    }
  }
  
  /* Dark mode styles */
  .Coc_dark__OnApF {
    background-color: #121212; /* Dark background */
    color: #f1f1f1; /* Light text */
  }
  
  .Coc_dark__OnApF .Coc_chatContainer__tkcrq {
    background-color: #1e1e1e; /* Darker chat container */
    color: #f1f1f1;
  }
  
  .Coc_dark__OnApF .Coc_chatWindow__Rp0IJ {
    background-color: #1e1e1e;
  }
  
  /* .dark .customInput {
    background-color: #333333; 
    border-color: #444444;
    color: #ffffff;
  } */
  
  .Coc_dark__OnApF .Coc_customInput__xXONf::placeholder {
    color: #fff;
  }
  
  .Coc_dark__OnApF .Coc_attachButton__WCfK1 {
    color: #fff;
  }
  
  .Coc_dark__OnApF .Coc_sendButton__S9Wp7 {
    background-color: #444444 !important; /* Darker send button */
  }
  
  .Coc_themeToggleIcon__C\\+VeA {
    color: #ffeb3b; /* Yellow for light mode */
  }
  
  .Coc_dark__OnApF .Coc_themeToggleIcon__C\\+VeA {
    color: #ffffff; /* White for dark mode */
  }
  
  .Coc_dark__OnApF .Coc_inputSection__RDnsb {
    background-color: #1e1e1e;
  }
  
  .Coc_dark__OnApF .Coc_header__NMYv8 {
    background-color: #1e1e1e;
  }
  
  .Coc_dark__OnApF .Coc_backButtonContainer__9zZLV {
    background-color: #1e1e1e;
  }
  
  .Coc_dark__OnApF .Coc_inputWrapper__P3Y34:focus-within {
    border-color: #fff;
    box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);
  }
  
  .Coc_dark__OnApF .Coc_deleteIcon__W893G {
    color: #fff;
  }
  
  .Coc_dark__OnApF .Coc_sendButton__S9Wp7 {
    background-color: #333333 !important;
    color: #fff !important;
  }
  
  .Coc_dark__OnApF .Coc_backButton__9qk2X {
    background-color: #333333 !important; /* Color of the Back to Home button */
    color: #fff !important;
  }
  
  .Coc_dark__OnApF .Coc_micButton__M4lN7 {
    color: #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/component/dashboard/chat/codeofconduct/Coc.module.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,8BAA8B;EAC7C,2BAA2B,EAAE,kCAAkC;EAC/D,gBAAgB,EAAE,+BAA+B;AACnD;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;EAC3B,wCAAwC,EAAE,4BAA4B;EACtE,aAAa;EACb,iCAAiC;EACjC,kBAAkB,EAAE,oCAAoC;AAC1D;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,yBAAyB,EAAE,oCAAoC;IAC/D,gCAAgC,EAAE,mBAAmB;EACvD;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,WAAW,EAAE,+BAA+B;IAC5C,YAAY;IACZ,kBAAkB,EAAE,kBAAkB;IACtC,iBAAiB,EAAE,gCAAgC;EACrD;;EAEA;IACE,aAAa;IACb,sBAAsB,EAAE,0BAA0B;EACpD;;EAEA;IACE,eAAe;IACf,iBAAiB,EAAE,2BAA2B;EAChD;;EAEA;IACE,mBAAmB,EAAE,mCAAmC;IACxD,cAAc,EAAE,0BAA0B;IAC1C,aAAa,EAAE,sCAAsC;IACrD,mBAAmB,EAAE,sBAAsB;EAC7C;;EAEA;IACE,gBAAgB;IAChB,UAAU,EAAE,oBAAoB;IAChC,WAAW,EAAE,oBAAoB;IACjC,yBAAyB,EAAE,gBAAgB;IAC3C,kBAAkB,EAAE,qBAAqB;IACzC,iBAAiB,EAAE,+BAA+B;EACpD;;EAEA;IACE,YAAY,EAAE,mCAAmC;IACjD,aAAa,EAAE,4BAA4B;IAC3C,gBAAgB,EAAE,2BAA2B;IAC7C,kBAAkB;IAClB,yBAAyB,EAAE,8BAA8B;EAC3D;;EAEA;IACE,aAAa;IACb,aAAa,EAAE,uCAAuC;EACxD;;EAEA;IACE,2BAA2B,EAAE,gCAAgC;IAC7D,iBAAiB;EACnB;;EAEA;IACE,yBAAyB,EAAE,kCAAkC;IAC7D,iBAAiB;EACnB;;EAEA;IACE,kBAAkB,EAAE,gCAAgC;IACpD,mBAAmB,EAAE,iCAAiC;IACtD,mBAAmB;IACnB,aAAa;IACb,cAAc,EAAE,4BAA4B;IAC5C,WAAW,EAAE,eAAe;IAC5B,kBAAkB;IAClB,qBAAqB,EAAE,oCAAoC;EAC7D;;EAEA;IACE,iBAAiB,EAAE,kDAAkD;IACrE,eAAe;IACf,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW,EAAE,gBAAgB;IAC7B,YAAY;IACZ,kBAAkB,EAAE,oBAAoB;IACxC,cAAc,EAAE,wBAAwB;EAC1C;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,4BAA4B;IAC5B,gBAAgB;IAChB,SAAS;IACT,WAAW;EACb;;;EAGA,iCAAiC;EACjC;IACE,aAAa;IACb,qBAAqB;IACrB,gBAAgB;IAChB,+BAA+B;IAC/B,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;EAChB;;EAEA,yBAAyB;EACzB;IACE,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,YAAY,EAAE,4BAA4B;IAC1C,gBAAgB,EAAE,uCAAuC;IACzD,cAAc;EAChB;;EAEA,8BAA8B;EAC9B;IACE,cAAc;IACd,iBAAiB;EACnB;;;EAGA,2BAA2B;EAC3B;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA,wBAAwB;EACxB;IACE,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;;EAGA,wCAAwC;EACxC;IACE,sBAAsB;IACtB,sBAAsB;EACxB;;;EAGA,gCAAgC;EAChC;IACE,cAAc,EAAE,uCAAuC;IACvD,uCAA4B;EAC9B;;EAEA,wDAAwD;EACxD;IACE,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,yCAA8B;EAChC;;EAEA,yCAAyC;EACzC;IACE;MACE,mBAAmB;MACnB,UAAU;IACZ;IACA;MACE,qBAAqB;MACrB,YAAY;IACd;IACA;MACE,mBAAmB;MACnB,UAAU;IACZ;EACF;;EAEA,iCAAiC;EACjC;IACE;;MAEE,oBAAoB;IACtB;IACA;MACE,sBAAsB;IACxB;EACF;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,kDAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;IACrB,sCAAsC;EACxC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,6BAA6B,EAAE,qCAAqC;IACpE,kBAAkB;IAClB,6CAAkC;EACpC;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA,iCAAiC;EACjC;IACE,yBAAyB;EAC3B;;EAEA,0DAA0D;EAC1D;IACE,WAAW,EAAE,2BAA2B;IACxC,mBAAmB,EAAE,oBAAoB;EAC3C;;EAEA;IACE,yBAAyB,EAAE,iCAAiC;IAC5D,mBAAmB,EAAE,kCAAkC;EACzD;;EAEA;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,iCAAiC;EACjC;IACE,qBAAqB,EAAE,+BAA+B;IACtD,gCAAgC,EAAE,gCAAgC;EACpE;;EAEA;IACE,mBAAmB,EAAE,gCAAgC;EACvD;;EAEA,sEAAsE;EACtE;IACE,mBAAmB,EAAE,gBAAgB;EACvC;;EAEA;IACE,yBAAyB,EAAE,iCAAiC;IAC5D,mBAAmB,EAAE,kCAAkC;EACzD;;EAEA;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;EAEA,kCAAkC;EAClC;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;IAC3C,aAAa;IACb,yBAAyB,EAAE,4CAA4C;IACvE,WAAW,EAAE,oDAAoD;EACnE;;EAEA;IACE,oCAAoC,EAAE,qCAAqC;IAC3E,sBAAsB;IACtB,8BAA8B;IAC9B,6BAA6B;IAC7B,oBAAoB,EAAE,sBAAsB;EAC9C;;EAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;KA6BG;;EAEH;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,uCAA4B;EAC9B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE;;;MAGE,YAAY;IACd;IACA;MACE,UAAU;IACZ;EACF;;EAEA,qCAAqC;EACrC;IACE;MACE,eAAe;IACjB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA,qBAAqB;EACrB;IACE,yBAAyB,EAAE,oBAAoB;IAC/C,cAAc,EAAE,eAAe;EACjC;;EAEA;IACE,yBAAyB,EAAE,0BAA0B;IACrD,cAAc;EAChB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;;;KAIG;;EAEH;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oCAAoC,EAAE,uBAAuB;EAC/D;;EAEA;IACE,cAAc,EAAE,0BAA0B;EAC5C;;EAEA;IACE,cAAc,EAAE,wBAAwB;EAC1C;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,oCAAoC,EAAE,qCAAqC;IAC3E,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb","sourcesContent":["\n.outerContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh; /* Full height for centering */\n  background-color: #edf6f778; /* Light background for contrast */\n  overflow: hidden; /* Prevent overflow if needed */\n}\n\n  \n.chatContainer {\n  width: 100%;\n  height: 100%;\n  max-width: 1300px;\n  max-height: 1200px;\n  overflow: hidden !important;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n  display: flex;\n  flex-direction: column !important;\n  position: relative; /* Ensure it's fixed to the screen */\n}\n\n  .header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 1rem;\n    background-color: #ffffff; /* White background for the header */\n    border-bottom: 1px solid #e0e0e0; /* Separator line */\n  }\n  \n  .botInfo {\n    display: flex;\n    align-items: center;\n  }\n  \n  .botIcon {\n    width: 50px; /* Fixed size for consistency */\n    height: 50px;\n    border-radius: 50%; /* Circular icon */\n    margin-right: 5px; /* Space between icon and text */\n  }\n  \n  .botDetails {\n    display: flex;\n    flex-direction: column; /* Stack name and status */\n  }\n  \n  .botName {\n    font-size: 17px;\n    font-weight: bold; /* Bold font for bot name */\n  }\n  \n  .onlineStatus {\n    font-size: 0.775rem; /* Smaller font for online status */\n    color: #6c757d; /* Gray color for status */\n    display: flex; /* Use flexbox to align dot and text */\n    align-items: center; /* Center vertically */\n  }\n  \n  .statusDot {\n    margin-left: 5px;\n    width: 8px; /* Size of the dot */\n    height: 8px; /* Size of the dot */\n    background-color: #4caf50; /* Green color */\n    border-radius: 50%; /* Make it circular */\n    margin-right: 5px; /* Space between dot and text */\n  }\n  \n  .chatWindow {\n    flex-grow: 1; /* Let it take up remaining space */\n    padding: 1rem; /* Space for chat messages */\n    overflow-y: auto; /* Enable vertical scroll */\n    overflow-x: hidden;\n    background-color: #ffffff; /* White background for chat */\n  }\n  \n  .messageContainer {\n    display: flex;\n    margin: 5px 0; /* Adjusted margin for closer spacing */\n  }\n  \n  .leftMessage {\n    justify-content: flex-start; /* Align left for bot messages */\n    text-align: start;\n  }\n  \n  .rightMessage {\n    justify-content: flex-end; /* Align right for user messages */\n    text-align: start;\n  }\n  \n  .message {\n    padding: 15px 15px; /* Padding for message bubbles */\n    border-radius: 10px; /* Rounded corners for messages */\n    align-items: center; \n    display: flex;\n    max-width: 50%; /* Limit width of messages */\n    color: #333; /* Text color */\n    position: relative; \n    word-wrap: break-word; /* Ensure long text wraps properly */\n  }\n  \n  .soundButton {\n    margin-left: 10px; /* Add space between the text and the sound icon */\n    cursor: pointer;\n    transition: color 0.3s;\n    align-self: flex-end;\n  }\n  \n  .soundButton:hover {\n    color: #333;\n  }\n  \n  .botMessage {\n    background-color: #ebeaea; \n  }\n  \n  .userMessage {\n    background-color: #c8e6c9; \n  }\n  \n  .avatar {\n    width: 50px; /* Avatar size */\n    height: 50px;\n    border-radius: 50%; /* Circular avatar */\n    margin: 0 10px; /* Space around avatar */\n  }\n  \n  /* Input Section */\n  .inputSection {\n    display: flex;\n    align-items: center;\n    padding: 10px 15px;\n    background-color: #ffffff;\n    border-radius: 0 0 20px 20px;\n    position: sticky;\n    bottom: 0; \n    width: 100%;\n  }\n  \n  \n  /* Wrapper for the custom input */\n  .inputWrapper {\n    display: flex;\n    align-items: flex-end;\n    padding: 4px 8px;\n    /* border: 1px solid #e0e0e0; */\n    border-radius: 20px;\n    background-color: #ebeaea;\n    margin-right: 16px; \n    position: relative;\n    width: 100%;\n    /* min-width: 300px; */\n    max-width: 1000px; \n    margin: 0 auto;\n  }\n  \n  /* Custom input styling */\n  .customInput {\n    flex-grow: 1;\n    border: transparent;\n    outline: none;\n    background-color: transparent;\n    padding: 8px;\n    font-size: 1rem;\n    line-height: 24px;\n    resize: none; /* Disable manual resizing */\n    overflow-y: auto; /* Add scrollbar if content overflows */\n    color: inherit;\n  }\n  \n  /* Attachment button styling */\n  .attachButton {\n    color: inherit;\n    margin-right: 8px;\n  }\n  \n  \n  /* Mic button positioning */\n  .micButton {\n    color: inherit;\n    margin-right: 8px;\n    transition: all 0.3s ease;\n  }\n  \n  /* Send Button styling */\n  .sendButton {\n    background-color: #c9d1d8;\n    color: #000;\n    border: none;\n    border-radius: 50%;\n    padding: 10px;\n    width: 40px;\n    height: 40px;\n    transition: background-color 0.3s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .disabledButton {\n    opacity: 0.5;\n    cursor: not-allowed; \n  }\n  \n  \n  /* Dark mode styling for input wrapper */\n  .darkInputWrapper {\n    background-color: #333;\n    border: 1px solid #555;\n  }\n  \n  \n  /* Pulse effect when listening */\n  .micButton.listening {\n    color: #ff4081; /* Color to indicate active listening */\n    animation: pulse 1s infinite;\n  }\n  \n  /* Add pulse effect around the mic icon when listening */\n  .listeningPulse {\n    border: 3px solid rgba(0, 150, 255, 0.5);\n    border-radius: 50%;\n    padding: 8px;\n    animation: pulse 1.5s infinite;\n  }\n  \n  /* Pulsing animation for listening mode */\n  @keyframes pulse {\n    0% {\n      transform: scale(1);\n      opacity: 1;\n    }\n    50% {\n      transform: scale(1.2);\n      opacity: 0.8;\n    }\n    100% {\n      transform: scale(1);\n      opacity: 1;\n    }\n  }\n  \n  /* Listening waveform animation */\n  @keyframes wave {\n    0%,\n    100% {\n      transform: scaleY(1);\n    }\n    50% {\n      transform: scaleY(1.5);\n    }\n  }\n  \n  .listeningWave {\n    display: flex;\n    gap: 2px;\n  }\n  \n  .waveBar {\n    width: 5px;\n    height: 16px;\n    background: #2196f3;\n    animation: wave 1s infinite ease-in-out;\n    animation-delay: calc(0.2s * var(--i));\n  }\n  \n  .inputWrapper:focus-within {\n    border-color: #000000;\n    box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  }\n  \n  .spinner {\n    width: 20px;\n    height: 20px;\n    border: 3px solid #ddd;\n    border-top: 3px solid #3f51b5; /* or any color matching your theme */\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n  \n  /* Hover effect for send button */\n  .sendButton:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Custom scrollbar for WebKit browsers (Chrome, Safari) */\n  .chatWindow::-webkit-scrollbar {\n    width: 10px; /* Width of the scrollbar */\n    border-radius: 10px; /* Rounded corners */\n  }\n  \n  .chatWindow::-webkit-scrollbar-thumb {\n    background-color: #007bff; /* Color of the scrollbar thumb */\n    border-radius: 10px; /* Rounded corners for the thumb */\n  }\n  \n  .chatWindow::-webkit-scrollbar-thumb:hover {\n    background-color: #0056b3; /* Darker color on hover */\n  }\n  \n  /* Custom scrollbar for Firefox */\n  .chatWindow {\n    scrollbar-width: thin; /* Make the scrollbar thinner */\n    scrollbar-color: #007bff #f0f4f8; /* Thumb color and track color */\n  }\n  \n  .chatWindow::-moz-scrollbar {\n    border-radius: 10px; /* Rounded corners for Firefox */\n  }\n  \n  /* Optional: Adjust the appearance of the scrollbar track in Firefox */\n  .chatWindow::-moz-scrollbar-track {\n    background: #f0f4f8; /* Track color */\n  }\n  \n  .chatWindow::-moz-scrollbar-thumb {\n    background-color: #007bff; /* Color of the scrollbar thumb */\n    border-radius: 10px; /* Rounded corners for the thumb */\n  }\n  \n  .chatWindow::-moz-scrollbar-thumb:hover {\n    background-color: #0056b3; /* Darker color on hover */\n  }\n  \n  /* Add style for the delete icon */\n  .deleteIcon {\n    cursor: pointer;\n  }\n  \n  .backButtonContainer {\n    display: flex;\n    justify-content: center; /* Center horizontally */\n    align-items: center; /* Center vertically */\n    padding: 1rem;\n    background-color: #f9f9f9; /* Light background for the button section */\n    width: 100%; /* Ensure the button container takes up full width */\n  }\n  \n  .backButton {\n    background-color: #c9d1d8 !important; /* Color of the Back to Home button */\n    color: #000 !important;\n    border-radius: 20px !important;\n    padding: 10px 20px !important;\n    text-transform: none; /* Disable uppercase */\n  }\n  \n  /* .typingIndicator {\n    display: flex;\n    gap: 5px;\n    margin: 0.5rem 1rem;\n  }\n  \n  .typingDot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background-color: #888;\n    animation: typing 0.8s infinite;\n  }\n  \n  .typingDot:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  \n  .typingDot:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  @keyframes typing {\n    0%, 100% {\n      transform: translateY(0);\n    }\n    50% {\n      transform: translateY(-5px);\n    }\n  } */\n  \n  .typingDots {\n    display: flex;\n    gap: 4px;\n  }\n  \n  .dot {\n    width: 8px;\n    height: 8px;\n    background-color: #aaa;\n    border-radius: 50%;\n    animation: blink 1s infinite;\n  }\n  \n  .dot:nth-child(2) {\n    animation-delay: 0.2s;\n  }\n  \n  .dot:nth-child(3) {\n    animation-delay: 0.4s;\n  }\n  \n  @keyframes blink {\n    0%,\n    20%,\n    100% {\n      opacity: 0.2;\n    }\n    50% {\n      opacity: 1;\n    }\n  }\n  \n  /* Responsive positioning if needed */\n  @media (max-width: 600px) {\n    .backButtonContainer {\n      padding: 0.5rem;\n    }\n  \n    .backButton {\n      font-size: 0.875rem;\n    }\n  }\n  \n  /* Dark mode styles */\n  .dark {\n    background-color: #121212; /* Dark background */\n    color: #f1f1f1; /* Light text */\n  }\n  \n  .dark .chatContainer {\n    background-color: #1e1e1e; /* Darker chat container */\n    color: #f1f1f1;\n  }\n  \n  .dark .chatWindow {\n    background-color: #1e1e1e;\n  }\n  \n  /* .dark .customInput {\n    background-color: #333333; \n    border-color: #444444;\n    color: #ffffff;\n  } */\n  \n  .dark .customInput::placeholder {\n    color: #fff;\n  }\n  \n  .dark .attachButton {\n    color: #fff;\n  }\n  \n  .dark .sendButton {\n    background-color: #444444 !important; /* Darker send button */\n  }\n  \n  .themeToggleIcon {\n    color: #ffeb3b; /* Yellow for light mode */\n  }\n  \n  .dark .themeToggleIcon {\n    color: #ffffff; /* White for dark mode */\n  }\n  \n  .dark .inputSection {\n    background-color: #1e1e1e;\n  }\n  \n  .dark .header {\n    background-color: #1e1e1e;\n  }\n  \n  .dark .backButtonContainer {\n    background-color: #1e1e1e;\n  }\n  \n  .dark .inputWrapper:focus-within {\n    border-color: #fff;\n    box-shadow: 0 0 5px rgba(255, 255, 255, 0.5);\n  }\n  \n  .dark .deleteIcon {\n    color: #fff;\n  }\n  \n  .dark .sendButton {\n    background-color: #333333 !important;\n    color: #fff !important;\n  }\n  \n  .dark .backButton {\n    background-color: #333333 !important; /* Color of the Back to Home button */\n    color: #fff !important;\n  }\n  \n  .dark .micButton {\n    color: #fff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outerContainer": `Coc_outerContainer__8agfj`,
	"chatContainer": `Coc_chatContainer__tkcrq`,
	"header": `Coc_header__NMYv8`,
	"botInfo": `Coc_botInfo__EU6fE`,
	"botIcon": `Coc_botIcon__6vATY`,
	"botDetails": `Coc_botDetails__JYn28`,
	"botName": `Coc_botName__YYZqs`,
	"onlineStatus": `Coc_onlineStatus__wgmzs`,
	"statusDot": `Coc_statusDot__V+wN4`,
	"chatWindow": `Coc_chatWindow__Rp0IJ`,
	"messageContainer": `Coc_messageContainer__ZB65G`,
	"leftMessage": `Coc_leftMessage__Rm4vy`,
	"rightMessage": `Coc_rightMessage__R67Jq`,
	"message": `Coc_message__znKSt`,
	"soundButton": `Coc_soundButton__1HKsw`,
	"botMessage": `Coc_botMessage__dZ63w`,
	"userMessage": `Coc_userMessage__MKIVA`,
	"avatar": `Coc_avatar__HtfhF`,
	"inputSection": `Coc_inputSection__RDnsb`,
	"inputWrapper": `Coc_inputWrapper__P3Y34`,
	"customInput": `Coc_customInput__xXONf`,
	"attachButton": `Coc_attachButton__WCfK1`,
	"micButton": `Coc_micButton__M4lN7`,
	"sendButton": `Coc_sendButton__S9Wp7`,
	"disabledButton": `Coc_disabledButton__nJXbJ`,
	"darkInputWrapper": `Coc_darkInputWrapper__NEiC7`,
	"listening": `Coc_listening__7E9ls`,
	"pulse": `Coc_pulse__4J0kM`,
	"listeningPulse": `Coc_listeningPulse__CNdAH`,
	"listeningWave": `Coc_listeningWave__jRHu4`,
	"waveBar": `Coc_waveBar__FOV-z`,
	"wave": `Coc_wave__8t0r5`,
	"spinner": `Coc_spinner__TEeDt`,
	"spin": `Coc_spin__sV3o1`,
	"deleteIcon": `Coc_deleteIcon__W893G`,
	"backButtonContainer": `Coc_backButtonContainer__9zZLV`,
	"backButton": `Coc_backButton__9qk2X`,
	"typingDots": `Coc_typingDots__BtzfO`,
	"dot": `Coc_dot__4V2-P`,
	"blink": `Coc_blink__OaKTI`,
	"dark": `Coc_dark__OnApF`,
	"themeToggleIcon": `Coc_themeToggleIcon__C+VeA`
};
export default ___CSS_LOADER_EXPORT___;
